import { Component, DestroyRef, effect, EventEmitter, inject, input, Input, Output, SimpleChanges } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { DiscountType } from 'src/app/models/discount-type.model';
import { Settlement } from 'src/app/models/settlement.model';
import { UnitOperationsState } from 'src/app/models/unit-operations-state.model';
import { SettlementsService } from 'src/app/services/settlements.service';
import {
  buildDiscountTypeReference,
  DEFAULT_DISCOUNT_TYPE_ID,
  DEFAULT_DISCOUNT_TYPES,
  getDiscountTypeOptionLabel,
  resolveBoolean,
  resolveDiscountTypeId
} from 'src/app/shared/utils/discount-type.utils';

@Component({
  selector: 'app-form-unit',
  template: `
    <form [formGroup]="unitForm" (ngSubmit)="saveUnit()">
      <fieldset [disabled]="saving()">
      <div class="row">
        <div class="col-md-12">
          <div class="form-group required">
            <label for="name" class="form-label text-sm">Nombre de la unidad</label>
            <input ngbTooltip="Departamento, Área, Negocio, etc." type="text" class="form-control" id="name" placeholder="" formControlName="name">
            <div *ngIf="ufc['name'].touched && ufc['name'].invalid">
              <div *ngIf="ufc['name'].errors?.['required']" class="text-danger text-sm">El nombre de la unidad es requerido.</div>
            </div>
          </div>
          <div class="form-group mt-3">
            <label for="number" class="form-label text-sm">Clave de la unidad</label>
            <input type="text" class="form-control" id="number" placeholder="" formControlName="number">
          </div>
          <!-- div class="form-group mt-3">
            <label for="unit_type_id" class="form-label text-sm">Tipo de unidad</label>
            <select class="form-select" formControlName="unit_type_id">
              <option value="0" selected disabled>Selecciona un tipo de unidad</option>
              <option value="1">Departamento</option>
              <option value="2">Casa</option>
              <option value="3">Local comercial</option>
              <option value="4">Oficina</option>
            </select>
            <div *ngIf="ufc['unit_type_id'].touched && ufc['unit_type_id'].invalid">
              <div *ngIf="ufc['unit_type_id'].errors?.['required']" class="text-danger text-sm">El tipo de unidad es requerido.</div>
            </div>
          </div -->
          <div class="form-group required mt-3">
            <label for="status" class="form-label text-sm">Estado de unidad</label>
            <select class="form-select" formControlName="status">
              <option [ngValue]="null" disabled>Selecciona el estado de la unidad</option>
              <option [ngValue]="1">Activo</option>
              <option [ngValue]="0">Inactivo</option>
            </select>
          </div>

          <div class="form-group mt-3">
            <label for="factor" class="form-label text-sm">Factor</label>
            <input type="number" min="0.1" step="0.1" class="form-control" id="factor" placeholder="" formControlName="factor">
            <div *ngIf="ufc['factor'].touched && ufc['factor'].invalid">
              <div *ngIf="ufc['factor'].errors?.['required']" class="text-danger text-sm">El factor es requerido.</div>
              <div *ngIf="ufc['factor'].errors?.['min']" class="text-danger text-sm">El factor mínimo requerido es 0.1.</div>
            </div>
          </div>
          <div class="form-group mt-3">
            <label for="admin_price" class="form-label text-sm">Costo administrativo ($ IVA incluido)</label>
            <input type="number" class="form-control" id="admin_price" placeholder="" formControlName="admin_price">
            <div *ngIf="ufc['admin_price'].touched && ufc['admin_price'].invalid">
              <div *ngIf="ufc['admin_price'].errors?.['required']" class="text-danger text-sm">El costo administrativo es requerido.</div>
            </div>
          </div>
          <div class="form-group mt-3">
            <label for="interests" class="form-label text-sm">Cargos moratorios (%)</label>
            <input type="number" class="form-control" id="interests" placeholder="" formControlName="interests">
            <div *ngIf="ufc['interests'].touched && ufc['interests'].invalid">
              <div *ngIf="ufc['interests'].errors?.['required']" class="text-danger text-sm">El factor es requerido.</div>
            </div>
          </div>
          <div class="form-group mt-3">
            <label for="reconexion_fee" class="form-label text-sm">Costo de reconexión ($ IVA incluido)</label>
            <input type="number" class="form-control" id="reconexion_fee" placeholder="" formControlName="reconexion_fee">
            <div *ngIf="ufc['reconexion_fee'].touched && ufc['reconexion_fee'].invalid">
              <div *ngIf="ufc['reconexion_fee'].errors?.['required']" class="text-danger text-sm">El costo de reconexión es requerido.</div>
            </div>
          </div>
          <div class="form-group mt-3">
            <label for="discount_type_id" class="form-label text-sm">Tipo de descuento</label>
            <select class="form-select" id="discount_type_id" formControlName="discount_type_id">
              <option *ngFor="let discountType of discountTypes" [ngValue]="discountType.id">
                {{ discountTypeOptionLabel(discountType) }}
              </option>
            </select>
            <div *ngIf="ufc['discount_type_id'].touched && ufc['discount_type_id'].invalid">
              <div *ngIf="ufc['discount_type_id'].errors?.['required']" class="text-danger text-sm">
                El tipo de descuento es requerido.
              </div>
            </div>
          </div>
          <div class="form-group mt-3">
            <label for="discount" class="form-label text-sm">{{ discountInputLabel }}</label>
            <div class="input-group">
              <span *ngIf="discountSymbol === '$'" class="input-group-text">{{ discountSymbol }}</span>
              <input type="number" min="0" step="0.01" class="form-control" id="discount" placeholder="" formControlName="discount">
              <span *ngIf="discountSymbol !== '$'" class="input-group-text">{{ discountSymbol }}</span>
            </div>
            <div *ngIf="ufc['discount'].touched && ufc['discount'].invalid">
              <div *ngIf="ufc['discount'].errors?.['required']" class="text-danger text-sm">El número de descuento es requerido.</div>
              <div *ngIf="ufc['discount'].errors?.['min']" class="text-danger text-sm">El descuento no puede ser negativo.</div>
              <div *ngIf="ufc['discount'].errors?.['pattern']" class="text-danger text-sm">El descuento admite hasta 2 decimales.</div>
            </div>
          </div>
          <div class="form-check mt-3 ms-4">
            <input class="form-check-input" type="checkbox" id="show_discount_on_receipt" formControlName="show_discount_on_receipt">
            <label class="form-check-label" for="show_discount_on_receipt">Mostrar descuento en el recibo</label>
          </div>
          <!-- <div class="form-group mt-3">
            <label for="discount" class="form-label text-sm">Periodicidad de recibos</label>
            <select class="form-select" formControlName="periodicity">
              <option value="" disabled>Selecciona una periodicidad</option>
              <option *ngFor="let period of periodicity" [value]="period.id">{{period.name}}</option>
            </select>
          </div> -->
          <div class="form-group mt-3">
            <label for="credit" class="form-label text-sm">Días de crédito</label>
            <input type="number" class="form-control" id="credit" placeholder="" formControlName="credit">
            <div *ngIf="ufc['credit'].touched && ufc['credit'].invalid">
              <div *ngIf="ufc['credit'].errors?.['required']" class="text-danger text-sm">El crédito es requerido.</div>
            </div>
          </div>
          <div class="form-group mt-3">
              <label for="start-operations-date" class="form-control-label">Fecha de inicio de operaciones</label>
              <input id="start-operations-date" type="date" class="form-control" formControlName="startOperationsDate">
          </div>
          <!-- div class="form-group mt-3">
            <label for="bedrooms" class="form-label text-sm">Habitaciones</label>
            <input type="number" class="form-control" id="bedrooms" placeholder="" formControlName="bedrooms">
            <div *ngIf="ufc['bedrooms'].touched && ufc['bedrooms'].invalid">
              <div *ngIf="ufc['bedrooms'].errors?.['required']" class="text-danger text-sm">El número de habitaciones es requerido.</div>
            </div>
          </div -->
          <!-- div class="form-group mt-3">
            <label for="bathrooms" class="form-label text-sm">Baños</label>
            <input type="number" class="form-control" id="bathrooms" placeholder="No. de baños" formControlName="bathrooms">
            <div *ngIf="ufc['bathrooms'].touched && ufc['bathrooms'].invalid">
              <div *ngIf="ufc['bathrooms'].errors?.['required']" class="text-danger text-sm">El número de baños es requerido.</div>
            </div>
          </div -->
          <!-- div class="form-group mt-3">
            <label for="parking" class="form-label text-sm">Lugares de estacionamiento</label>
            <input type="number" class="form-control" id="parking" placeholder="" formControlName="parking">
            <div *ngIf="ufc['parking'].touched && ufc['parking'].invalid">
              <div *ngIf="ufc['parking'].errors?.['required']" class="text-danger text-sm">Los lugares de estacionamiento es requerido.</div>
            </div>
          </div -->
          <!-- div class="form-group mt-3">
            <label for="area" class="form-label text-sm">Área (Mts.<sup>2</sup>)</label>
            <input type="number" class="form-control" id="area" placeholder="" formControlName="area">
            <div *ngIf="ufc['area'].touched && ufc['area'].invalid">
              <div *ngIf="ufc['area'].errors?.['required']" class="text-danger text-sm">El área es requerido.</div>
            </div>
          </div -->
          <!-- div class="form-group mt-3 d-none">
            <label for="floor_id" class="form-label text-sm">Piso</label>
            <input type="number" class="form-control" id="floor_id" placeholder="Piso" formControlName="floor_id">
            <div *ngIf="ufc['floor_id'].touched && ufc['floor_id'].invalid">
              <div *ngIf="ufc['floor_id'].errors?.['required']" class="text-danger text-sm">El piso es requerido.</div>
            </div>
          </div -->
          <div class="form-group mt-3 text-end">
            <!-- button type="button" class="btn btn-link btn-sm me-2" (click)="cancel()">Cancelar</!-->
            <button type="submit" class="btn btn-outline-success" [disabled]="saving()">
              @if (saving()) { <span class="spinner-border spinner-border-sm me-2" aria-hidden="true"></span> }
              Guardar
            </button>
          </div>
        </div>
      </div>
      </fieldset>
    </form>
  `,
  styleUrls: []
})
export class FormUnitComponent {
  settlementBaseData = input<Settlement | null>();
  store = inject(SettlementsService);
  discountTypes: DiscountType[] = [...DEFAULT_DISCOUNT_TYPES];
  saving = input(false);
  private operations: UnitOperationsState | null = null;
  @Input() set operationsState(state: UnitOperationsState | null) {
    if (this.operations?.startDate && !state?.startDate) {
      this.unitForm.get('startOperationsDate')?.reset('', { emitEvent: false });
    }
    this.operations = state;
    this.syncOperationsDate();
  }
  private _unit: any;
  @Input() set unit(value: any) {
    if (value) {
      const changedUnit = value.id !== this._unit?.id;
      this._unit = value;
      if (changedUnit) this.unitForm.get('startOperationsDate')?.reset('');
      this.unitForm.patchValue({
        ...value,
        status: ['', null, undefined].includes(value.status) ? null : Number(value.status),
        discount_type_id: resolveDiscountTypeId(value.discount_type_id ?? value.discount_type),
        show_discount_on_receipt: resolveBoolean(value.show_discount_on_receipt)
      });
      this.syncOperationsDate();
    } else {
      this._unit = null;
      const startOperationsDate = this.unitForm ? this.unitForm.get('startOperationsDate') : null;
      if (startOperationsDate) {
        startOperationsDate.disable();
      }
    }
  };

  get unit() {
    return this._unit;
  }
  @Input() floor_id: any;
  @Output() cancelUnit = new EventEmitter<any>();
  @Output() updateUnit = new EventEmitter<any>();

  unitForm: FormGroup = new FormGroup({});

  constructor(
    private toastr: ToastrService,
    private fb: FormBuilder
  ) {
    this.buildUnitForm();
    this.unitForm.get('status')!.valueChanges.pipe(takeUntilDestroyed(inject(DestroyRef)))
      .subscribe(() => this.syncOperationsDate());
    this.loadDiscountTypes();
    effect(() => {
      const settlement = this.settlementBaseData();
      if (settlement && !this.unit) {
        const {
          factor,
          admin_price,
          interests,
          reconexion_fee,
          discount,
          discount_type_id,
          show_discount_on_receipt,
          credit
        } = settlement;
        this.unitForm.patchValue({
          factor,
          admin_price,
          interests,
          reconexion_fee,
          discount,
          discount_type_id: resolveDiscountTypeId(discount_type_id),
          show_discount_on_receipt: resolveBoolean(show_discount_on_receipt),
          credit
        });
      }
    })
  }

  periodicity: any[] = [
    { id: 1, name: 'Semanal' },
    { id: 2, name: 'Quincenal' },
    { id: 3, name: 'Mensual' },
    { id: 4, name: 'Catorcenal' }
  ]

  buildUnitForm() {
    this.unitForm = this.fb.group({
      name: ['', Validators.required],
      number: [''],
      bedrooms: [''],
      bathrooms: [''],
      parking: [''],
      area: [''],
      unit_type_id: [''],
      floor_id: ['', Validators.required],
      factor: ['', [Validators.required, Validators.min(0.1)]],
      admin_price: [''],
      interests: [''],
      reconexion_fee: [''],
      discount_type_id: [DEFAULT_DISCOUNT_TYPE_ID, Validators.required],
      discount: ['', [Validators.min(0), Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
      show_discount_on_receipt: [false],
      status: [1, [Validators.required, Validators.pattern(/^[01]$/)]],
      //periodicity: [''],
      credit: [''],
      startOperationsDate: [{value: '', disabled: true}]
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    /* if (changes['unit'] && changes['unit'].currentValue) {
      this.unitForm.patchValue(this.unit);
    } */
    if (changes['floor_id'] && changes['floor_id'].currentValue) {
      this.unitForm.get('floor_id')?.setValue(this.floor_id);
    }
  }

  get ufc() {
    return this.unitForm.controls;
  }

  get selectedDiscountType(): DiscountType {
    const selectedId = resolveDiscountTypeId(this.ufc['discount_type_id']?.value);
    return this.discountTypes.find(type => type.id === selectedId) || DEFAULT_DISCOUNT_TYPES[0];
  }

  discountTypeOptionLabel(discountType: DiscountType): string {
    return getDiscountTypeOptionLabel(discountType);
  }

  get discountInputLabel(): string {
    return this.selectedDiscountType.name.toUpperCase() === 'PERCENTAGE'
      ? 'Porcentaje del descuento (%)'
      : 'Descuento por litro ($ IVA incluido)';
  }

  get discountSymbol(): string {
    return this.selectedDiscountType.symbol;
  }

  selectUnitType(e: any) {
    this.unitForm.patchValue({
      unit_type_id: e.target.value
    });
  }

  cancel() {
    this.cancelUnit.emit();
  }

  saveUnit() {
    if (this.saving()) return;
    if (this.unitForm.invalid) {
      this.unitForm.markAllAsTouched();
      this.toastr.error('Faltan campos por llenar', 'Error');
      return;
    }

    this.updateUnit.emit({
      ...this.unitForm.value,
      status: Number(this.ufc['status'].value),
      discount_type_id: buildDiscountTypeReference(this.ufc['discount_type_id'].value)
    });
  }

  private syncOperationsDate(): void {
    const control = this.unitForm.get('startOperationsDate');
    if (!control) return;
    const state = this.operations;
    const sameUnit = state && state.unitId === Number(this.unit?.id);
    const active = Number(this.unit?.status) === 1 && Number(this.ufc['status'].value) === 1;
    if (!sameUnit || !active || state.status === 'inactive') {
      control.reset('', { emitEvent: false });
      control.disable({ emitEvent: false });
    } else if (state.startDate) {
      control.setValue(state.startDate, { emitEvent: false });
      control.disable({ emitEvent: false });
    } else if (state.status === 'ready') {
      control.enable({ emitEvent: false });
    } else {
      control.disable({ emitEvent: false });
    }
  }

  private loadDiscountTypes(): void {
    this.store.getDiscountTypes().subscribe({
      next: (discountTypes) => {
        if (discountTypes.length) {
          this.discountTypes = discountTypes;
        }
      },
      error: () => {
        this.toastr.warning('No se pudo actualizar el catálogo de descuentos. Se usarán las opciones predeterminadas.');
      }
    });
  }
}
